import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/chat-list',
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '/chat-list',
                    name: 'chat list',
                    component: () => import("./views/chats.vue")
                },
                {
                    path: '/chat-list/:identifier',
                    name: 'chat detail',
                    component: () => import("./views/chatDetail.vue")
                },
            ]
        }
    ];
};